export const legal = {
  title_tos: "Terms of Service - Onelink.to (OLTO AB)",
  title_privacy: "Privacy Policy - Onelink.to (OLTO AB)",
  title_notice: "Legal Notice - Onelink.to (OLTO AB)",
  effective_from: "Effective from:",
};
